import Vue from "vue";

export const LIST_CURRENT_STREAM = (state, id) => {
  state.current = state.streams.data.find(item => item.id === +id);
};

export const FETCH_CURRENT_STREAM = (state, data) => {
  state.current = { ...state.current, ...data };
};

export const UPDATE_STREAM = (state, data) => {
  const index = state.streams.data.findIndex(item => item.id === data.id);

  // state.streams.data[index] = data;

  Vue.set(state.streams.data, index, data);
};

export const REMOVE_CURRENT_STREAM = (state, id) => {
  const index = state.streams.data.findIndex(item => item.id === id);

  if (index != -1) {
    state.streams.data.splice(index, 1);
  }

  // Vue.set(state.streams.data, index, data);
};

export const STATUS_SUCCESS = state => {
  state.streams.status = "success";
};

export const STATUS_ERROR = state => {
  state.streams.status = "error";
};

export const STATUS_WAITING = state => {
  state.streams.status = "waiting";
};

export const SET_STREAMS = (state, streams) => {
  state.streams.data = state.streams.data.concat(streams);
};

export const SET_SCOPE_STREAMS_LIST = (state, scope) => {
  state.streams.scope = scope;
};

export const SET_FILTER_STREAMS_LIST = (state, filter) => {
  state.streams.filter = filter;

  // Vue.set(state.streams, "filter", filter);
};
export const SET_SEARCH_STREAMS_LIST = (state, search) => {
  state.streams.search = search;
};

export const CLEAR_STATUS = state => {
  state.streams.status = null;
};

export const LIST_FINISHED = state => {
  state.streams.endOfList = true;
};

export const SET_LINKS_TO_STREAM = (
  state,
  { link_hls, link_rtmp, token_shared }
) => {
  state.current.link_hls = link_hls;
  state.current.link_rtmp = link_rtmp;
  state.current.token_shared = token_shared;
};

export const PLUS_PAGE = state => state.streams.page++;

export const CHANGE_LIKE_STREAM = (state, id) => {
  const stream = state.streams.data.find(item => item.id === id);

  if (stream) {
    stream.like = !stream.like;
  }
};

export const CLEAR_ALL = state => {
  state.current = {
    link_hls: null,
    link_rtmp: null,
    token_shared: null,
    owner_id: null,
    owner: {
      name: "",
      surname: "",
      id: "",
      avatar: ""
    }
  };
  state.streams.data = [];
  state.streams.page = 1;
  state.streams.scope = null;
  state.streams.filter = null;
  state.streams.status = null;
  state.streams.endOfList = false;
};

export const CLEAR_STREAMS = state => {
  state.current = {
    link_hls: null,
    link_rtmp: null,
    token_shared: null,
    owner_id: null,
    owner: {
      name: "",
      surname: "",
      id: "",
      avatar: ""
    }
  };
  state.streams.data = [];
  state.streams.page = 1;
  state.streams.status = null;
  state.streams.endOfList = false;
};
